import { imagePicker_template } from "../../../vendor/valnet/valnet_imagePicker/js/components/templates/imagePicker_template";
import { imagePickerHelper } from "../../../vendor/valnet/valnet_imagePicker/js/modules/imagePickerHelper";
import { multipleSelector_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { filterArticle_template } from "./filterArticle_template";
import { filterUser_template } from "./filterUser_template";
import { imageWidget_template } from "./imageWidget_template";

declare var ko: any;

export class channelsEdit_template extends vnTemplate {

    protected imagePicker: imagePicker_template;
    protected imagePickerHelper: imagePickerHelper;
    protected imageWidgetForBannerImage: imageWidget_template;
    protected imageWidgetForPicture: imageWidget_template;
    public creatorFilter: filterUser_template;
    protected socialMediaFilter : multipleSelector_template;
    public articleFilter: filterArticle_template;


    private readonly SOCIAL_MEDIA_LIST = [
        { "id": "facebook",    "name": "Facebook",    "selected": true,   "url": "" },
        { "id": "instagram",   "name": "Instagram",   "selected": true,   "url": "" },
        { "id": "twitter",     "name": "Twitter",     "selected": true,   "url": "" },
        { "id": "linkedin",    "name": "LinkedIn",    "selected": false,  "url": "" },
        { "id": "tiktok",      "name": "Tiktok",      "selected": true,   "url": "" },
        { "id": "muckrack",    "name": "Muck Rack",   "selected": false,  "url": "" },
        { "id": "opencritic",  "name": "OpenCritic",  "selected": false,  "url": "" },
        { "id": "mastodon",    "name": "Mastodon",    "selected": false,  "url": "" },
        { "id": "threads",     "name": "Threads",     "selected": false,  "url": "" },
        { "id": "wechat",      "name": "WeChat",      "selected": false,  "url": "" },
        { "id": "youtube",     "name": "YouTube",     "selected": true,   "url": "" },
        { "id": "twitch",      "name": "Twitch",      "selected": true,   "url": "" },
        { "id": "discord",     "name": "Discord",     "selected": false,  "url": "" },
        { "id": "pinterest",   "name": "Pinterest",   "selected": false,  "url": "" },
        { "id": "whatsapp",    "name": "WhatsApp",    "selected": false,  "url": "" },
        { "id": "reddit",      "name": "Reddit",      "selected": false,  "url": "" },
        { "id": "snapchat",    "name": "Snapchat",    "selected": false,  "url": "" },
        { "id": "substack",    "name": "Substack",    "selected": false,  "url": "" },
        { "id": "medium",      "name": "Medium",      "selected": false,  "url": "" },
        { "id": "tumblr",      "name": "Tumblr",      "selected": false,  "url": "" },
        { "id": "telegram",    "name": "Telegram",    "selected": false,  "url": "" },
        { "id": "signal",      "name": "Signal",      "selected": false,  "url": "" },
        { "id": "mail",        "name": "Email",       "selected": false,  "url": "" },
        { "id": "website",     "name": "Websites",    "selected": false,  "url": "" },
    ]

    static CHANNEL_INFO_TAB = "info";
    static CHANNEL_VIDEOS_TAB = "videos";

    protected getTemplateHtml(): string {

        return /*html*/ `
        <div class="w-form w-form-large view-tag channel-form">
            <div class="form-header">
                <h3 class="form-title icon i-channel"><span data-bind="text: $data.id() ? 'Edit' : 'Create' "></span>&nbsp;Channel</h3>
                <button type="button"  data-bind="event: { click: onClickClose }" class="close-button icon i-close-2"></button>
            </div>

            <div class="form-pagination">
                <button data-bind="event: { click: onClickSelectTab.bind($data, '${channelsEdit_template.CHANNEL_INFO_TAB}') }, css: { 'is-activated': selectedTab() == '${channelsEdit_template.CHANNEL_INFO_TAB}' }" class="btn icon i-channel" type="button"><span class="btn-text">Channel</span></button>
                <button data-bind="event: { click: onClickSelectTab.bind($data, '${channelsEdit_template.CHANNEL_VIDEOS_TAB}') }, css: { 'is-activated': selectedTab() == '${channelsEdit_template.CHANNEL_VIDEOS_TAB}' }" class="btn icon i-video-2" type="button"><span class="btn-text" data-bind="text: 'Videos' + (articles().length ? ' (' + articles().length + ')' : '')"></span></button>
            </div>

            <div class="ww-form-body" data-bind="css: { 'is-showing': selectedTab() == '${channelsEdit_template.CHANNEL_INFO_TAB}' }">
                <div class="w-form-body">
                    <div class="form-body">
                        <strong class="form-sub-title">Channel Information</strong>
                        <div class="form-group">
                            <input id="isAvailableForUse" type="checkbox" data-bind="checked: isAvailableForUse" />
                            <label for="isAvailableForUse" class="form-label icon i-check">Available for use</label>
                        </div>

                        <div class="form-group">
                            <label class="form-label">Name</label>
                            <div class="w-input">
                                <input type="text" name="name" id="name"  class="input-text" data-bind="value: name">
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="about" class="form-label">About</label>
                            <textarea id="about" name="about" class="input-text" data-bind="value: about"></textarea>
                        </div>

                        <div class="form-group">
                            <label for="" class="form-label">Creators</label>
                            ${this.creatorFilter.getHtmlBuild()}
                            <div class="w-filters-selected">
                                <div id="filters-selected" class="filters-selected">
                                    <div id="selected-creators"></div>
                                </div>
                            </div>
                        </div>

                        <strong class="form-sub-title">Social Media</strong>
                        <span data-bind="text: JSON.stringify(socialMediaLinks)"></span>
                        <div class="sub-header w-justify">
                            ${ this.socialMediaFilter.getHtmlBuild() }
                        </div>
                        <div class="w-form-group-two" data-bind="foreach: socialMediaLinks">
                            <div class="form-group" data-bind="visible: selected">
                                <label for="" class="form-label icon" data-bind="text: name, class: 'i-' + id"></label>
                                <input id=""  type="url" class="input-text" data-bind="value: url">
                            </div>
                        </div>
                    </div>

                    <div class="form-body channels-images">
                        <strong class="form-sub-title">Channel Pictures</strong>
                        <div class="form-group img">

                            <label class="form-label">Picture</label>
                            <div id="menu_image">
                            ${this.imageWidgetForPicture.getHtmlBuild()}
                            </div>

                        </div>
                        <div class="form-group" style="border-top: 1px dashed #d3d3d3; margin-top: 3rem; padding-top: 2rem;">
                            <div class="form-group img" style="margin: 0;">
                                <label for="" class="form-label">Banner</label>
                                ${this.imageWidgetForBannerImage.getHtmlBuild()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="ww-form-body" data-bind="css: { 'is-showing': selectedTab() == '${channelsEdit_template.CHANNEL_VIDEOS_TAB}' }">
                <strong class="form-sub-title">Video Articles</strong>
                <div class="form-group">
                    <label for="" class="form-label">Video Articles</label>
                    ${ this.articleFilter.getHtmlBuild() }
                    <div class="w-filters-selected">
                        <div id="filters-selected" class="filters-selected">
                            <div id="selected-articles">
                                <!-- ko if: articles().length > 0 -->
                                    <label class="small">Selected Videos</label>
                                    <div id="selected-articles-wrapper" class="w-pinned" data-bind="foreach: articles">
                                        <div class="pinned-form entry" data-bind="attr: { 'id': id }">
                                            <div class="w-btn">
                                                <button class="btn border only-icon icon border i-link" data-bind="event: { click: $parent.onClickArticle }" type="button"></button>
                                                <button class="btn border only-icon icon border highlight i-delete" data-bind="event: { click: $parent.onClickDeleteElement }" type="button"></button>
                                            </div>
                                            <div class="w-title">
                                                <div>
                                                    <span class="pinned-info" data-bind="text: 'ID: ' + id"></span>
                                                    <p class="pinned-info" data-bind="text: 'Last Published: ' + dateMostRecentPublishedStatus ? dateMostRecentPublishedStatus : 'Never Published'"></p>
                                                    <h5 class="pinned-title" data-bind="text: title"></h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                <!-- /ko -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-footer">
                <button type="button" data-bind="event: { click: onClickCancel }" class="btn ">Cancel</button>
                <button type="button" data-bind="event: { click: onClickSave }" class="btn highlight">Save</button>
            </div>
        </div>


        ${this.imagePicker.getHtmlBuild()}
        `;
    }

    protected initPartial(): void {
        this.imagePicker = new imagePicker_template("imagePicker", this.getTemplateViewModel(), this.caller);
        this.imagePickerHelper = new imagePickerHelper(this.imagePicker, this.caller.viewModel, this.caller.getVnAppZone(), this.caller);

        this.imageWidgetForBannerImage = new imageWidget_template("banner_image", this.getTemplateViewModel(), this);
        this.imageWidgetForBannerImage.setMode("single-select");
        this.imageWidgetForBannerImage.setCaller(this.imagePickerHelper);

        this.imageWidgetForPicture = new imageWidget_template("picture", this.getTemplateViewModel(), this);
        this.imageWidgetForPicture.setMode("single-select");
        this.imageWidgetForPicture.setCaller(this.imagePickerHelper);

        this.creatorFilter = new filterUser_template("creatorFilter", this.getTemplateViewModel(), this.caller);
        this.creatorFilter.asMultipleSelectionMode();
        this.creatorFilter.setTagContainerId("selected-creators");
        this.creatorFilter.setTagContainerCaption("Creators:");
        this.creatorFilter.setPlaceholderText("Creator");
        this.creatorFilter.setUniqueIdentifier("idCreators");
        this.creatorFilter.setIsLoadingAnimationEnable(true);

        this.socialMediaFilter = new multipleSelector_template("socialMediaFilter", this.getTemplateViewModel(), this.caller);
        this.socialMediaFilter.setLabel("Social Media");
        this.socialMediaFilter.setFilterContainerClass('margin-neg');
        this.socialMediaFilter.setTagContainerId('selected-socialMedias');
        this.socialMediaFilter.setTagContainerCaption('Selected Social Medias:');

        this.articleFilter = new filterArticle_template("articleFilter", this.getTemplateViewModel(), this.caller);
        this.articleFilter.setIsLoadingAnimationEnable(true);
        this.articleFilter.setSelectionMode(filterArticle_template.SINGLE_SELECTION_MODE);
        this.articleFilter.setShowDetails(true);
    }

    protected getTemplateName(): string {

        return "channelsEdit_template";
    }

    protected buildViewModel(): any {

        return {
            id: ko.observable(""),
            brand: ko.observable(""),
            name: ko.observable(""),
            about: ko.observable(""),
            isAvailableForUse: ko.observable(true),
            socialMediaLinks: ko.observable([]),
            articles: ko.observableArray([]),

            selectedTab: ko.observable(channelsEdit_template.CHANNEL_INFO_TAB),

            onClickEdit: this.onClickEdit.bind(this),
            onClickCancel: this.onClickCancel.bind(this),
            onClickClose: this.onClickClose.bind(this),
            onClickSave: this.onClickSave.bind(this),
            onClickSelectTab: this.onClickSelectTab.bind(this),
            onClickArticle: this.onClickArticle.bind(this),
            onClickDeleteElement: this.onClickDeleteElement.bind(this),
        }
    }


    public getViewModelForRequest() {
        const creators = this.creatorFilter.getUsersForRequest().map(user => {
            return user.id
        });

        let socialMediaLinks = this.getTemplateViewModel().socialMediaLinks().filter(socialMedia => {
            return socialMedia.selected && socialMedia.url;
        });

        let socialMedia = {};
        socialMediaLinks.forEach(socialMediaLink => {
            if(socialMediaLink.selected) {
                socialMedia[socialMediaLink.id] = socialMediaLink.url;
            }
        })

        return {
            id: this.getTemplateViewModel().id(),
            name: this.getTemplateViewModel().name(),
            about: this.getTemplateViewModel().about(),
            isAvailableForUse: this.getTemplateViewModel().isAvailableForUse(),
            socialMedia: socialMedia,
            banner: this.imageWidgetForBannerImage.getImage(),
            picture: this.imageWidgetForPicture.getImage(),
            creators: creators,
            articles: this.getArticles().map(article => { return article.id }),
        }
    }

    protected onClickDeleteElement(targetArticle, event): void {
        let articles = this.getArticles();
        articles = articles.filter(article => article.id !== targetArticle.id);
        this.setArticles(articles);
    }

    public setBrand(brand): void {

      this.getTemplateViewModel().brand(brand);
    }

    public onClickEdit() {
        this.caller.edit();
    }

    public setChannel(data): void {
        this.getTemplateViewModel().id(data.id);
        this.getTemplateViewModel().isAvailableForUse(data.isAvailableForUse);
        this.getTemplateViewModel().name(data.name);
        this.getTemplateViewModel().about(data.about);

        const creators = data.creators.map(user => {
            return {
                id: user.id,
                name: user.valnet_user ? user.valnet_user.fullName : "",
            }
        });

        this.creatorFilter.setSelectedUsersFromRequestParams(creators);

        this.setSocialMediaLinks(data.socialMedia, true);

        if(data.banner) {
            this.imageWidgetForBannerImage.setImage(data.banner);
        } else {
            this.imageWidgetForBannerImage.clearImage();
        }

        if(data.picture) {
            this.imageWidgetForPicture.setImage(data.picture);
        } else {
            this.imageWidgetForPicture.clearImage();
        }

        let sortedArticles = [];
        if(data.articles) {
            sortedArticles = data.articles.sort(this.sortArticles.bind(this));
        }

        this.getTemplateViewModel().articles(sortedArticles);
    }

    private sortArticles(a, b) {
        const dateA = new Date(a.dateMostRecentPublishedStatus).valueOf();
        const dateB = new Date(b.dateMostRecentPublishedStatus).valueOf();
        return dateB - dateA;
    }

    public addArticle(article) {
        if(article) {
            let articles = this.getArticles();
            if (!articles.some(a => a.id === article.id)) {
                articles.push(article);

                articles = articles.sort(this.sortArticles.bind(this));

                this.setArticles(articles);
            }
        }
    }

    public setSocialMediaLinks(socialMediaLinks, setDefault = false) {
        if(!socialMediaLinks) {
            socialMediaLinks = {};
        }

        let socialMediaList = [];

        this.SOCIAL_MEDIA_LIST.forEach((item) => {
            socialMediaList.push({
                id: item.id,
                name: item.name,
                selected: (setDefault && item.selected) || !!socialMediaLinks[item.id],
                url: socialMediaLinks[item.id],
            });
        });

        this.getTemplateViewModel().socialMediaLinks(socialMediaList);
        this.setSocialMediaSelectedItems(socialMediaList);
    }

    public setSocialMediaFilterItems(socialMedia = this.SOCIAL_MEDIA_LIST){

        this.socialMediaFilter.setItems(socialMedia);
        this.setSocialMediaSelectedItems(socialMedia);
    }

    protected setSocialMediaSelectedItems(selectedSocialMediaItems) {
        let socialMediaLinks = this.getTemplateViewModel().socialMediaLinks();
        selectedSocialMediaItems.forEach((item) => {
            if(socialMediaLinks[item.id]) {
                socialMediaLinks[item.id].selected = item.selected;
            }
        });

        let selectedItems = socialMediaLinks.filter(item => item.selected);
        this.socialMediaFilter.setSelectedItems(selectedItems);

        this.getTemplateViewModel().socialMediaLinks(selectedSocialMediaItems);
    }

    public setCreators(creators): void {
        this.creatorFilter.setUsers(creators);
    }

    protected filterSimpleOnChange(idElement) {
        this.caller.filterSimpleOnChange(idElement);
    }

    public onClickCancel() {
        const id = this.getTemplateViewModel().id();
        this.caller.cancel(id);
    }

    public onClickClose() {
        const id = this.getTemplateViewModel().id();
        this.caller.close(id);
    }

    public onClickSave() {
        this.caller.save();
    }

    public updateSocialMediaSelection() {
        let socialMediaLinks = this.getTemplateViewModel().socialMediaLinks();
        let selectedItems = this.socialMediaFilter.getSelectedItems();
        socialMediaLinks.forEach(link => {
            link.selected = !!selectedItems.find(item => item === link.id);
        });

        this.getTemplateViewModel().socialMediaLinks([]);
        this.getTemplateViewModel().socialMediaLinks(socialMediaLinks);
    }

    private onClickSelectTab(tab) {
        this.getTemplateViewModel().selectedTab(tab);
    }

    public getArticles() {
        return this.getTemplateViewModel().articles();
    }

    private setArticles(articles) {
        this.getTemplateViewModel().articles(articles);
    }
    public onClickArticle(article) {
        this.caller.showArticle(article);
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/channelsEdit_template.ts